import React from "react";
import HeroSection from "./HeroSection";
import AboutArea from "./AboutArea";
import PropertiesSlider from "./PropertiesSlider";
import ServiceSection from "./ServiceSection";
import SpecialOffer from "./SpecialOffer";
import ChairmanSection from "./ChairmanSection";
import BlogSection from "./BlogSection";

const Home = () => {
  return (
    <>
      <HeroSection />
      <AboutArea />
      <PropertiesSlider />
      <ServiceSection />
      <SpecialOffer />
      <ChairmanSection />
      <BlogSection />
    </>
  );
};

export default Home;
